export const DASHBOARD_CARDS = {
  FINANCIAL_BENCHMARK: "financialBenchmark",
  MISSED_EARNINGS: "missed_earnings",
  CONSUMER_BEHAVIOR: "consumer_behavior",
  OPPORTUNITIES: "opportunities",
  DEPOSITIES: "secondary_consumer",
  BEAT_THE_COMPETITION: "beat_the_competition",
  AUTOMATED_MARKETING: "automated_marketing",
  BANKING_SERVICES: "banking_services",
  GHOST_CONSUMERS: "ghost_consumer",
  TOP_PERSONA: "top_persona",
  DEMOGRAPHICS: "demographics",
  TOP_MERCHANTS: "top_merchant",
  TOP_VENDERS: "top_vendor",
  TREND_MISSED_EARNINGS: "missedrevenue_trend",
  TREND_BOND_SCORE: "bondscore_trend",
  TREND_OPPORTUNITIES: "opportunities_trend",
  TREND_DEPOSITS: "secondaryconsumer_trend",
  TREND_GHOST_CONSUMERS: "ghostconsumer_trend",
};